// @flow
import OrgsPage from './OrgsPage';

export default OrgsPage;
